export class ForwardClickComponent {
  private static linkedCardComponentInstance: ForwardClickComponent;
  private static readonly forwardClickSelector: string = '[data-js-forward-click]';
  private static readonly innerTargetSelector: string = '[data-js-inner-target]';

  public static get instance(): ForwardClickComponent {
    if (!ForwardClickComponent.linkedCardComponentInstance) {
      ForwardClickComponent.linkedCardComponentInstance = new ForwardClickComponent();
    }

    return ForwardClickComponent.linkedCardComponentInstance;
  }

  private handleCardClick(event: MouseEvent): void {
    const { innerTargetSelector } = ForwardClickComponent;
    const forwardClickElement = event.currentTarget as HTMLElement;
    const innerTarget: HTMLElement = forwardClickElement.querySelector(innerTargetSelector);

    if (!innerTarget) {
      return null;
    }

    innerTarget.click();
  }

  private setupEvents(): void {
    const { forwardClickSelector } = ForwardClickComponent;
    const forwardClickElements = document.querySelectorAll(forwardClickSelector);

    forwardClickElements.forEach((forwardClickElement) => {
      forwardClickElement.addEventListener('click', this.handleCardClick.bind(this));
    });
  }

  public init(): void {
    window.addEventListener('load', this.setupEvents.bind(this));
  }

  protected constructor() { }
}
